import DefaultDetail from "@Common/DefaultDetail";
import { useParams } from "react-router-dom";

const TestSiteDetail = () => {
    const { secondParam } = useParams();

    let inputs = [
        {
            blockName: "Конфиг для аб теста",
            inputs: {
                title: { label: "Название", type: "string", required: true },
                description: { label: "Описание", type: "string" },
                code: { label: "Код(Уникальный!!!!)", type: "string", required: true },
                active: { label: "Активность", type: "checkbox" },
                dateStart: { label: "Дата начала", type: "date", required: true },
                dateEnd: { label: "Дата окончания", type: "date", required: true },
                siteIds: {
                    label: "Сайты на которых используется",
                    type: "multiSelectSuggest",
                    required: false,
                    apiUrl: "/promo/suggest_list?collection=sites&project[_id]=1&project[code]=1&project[name]=1&sortField=name&sortOrder=asc&filters[active]=true",
                    dataKey: "suggest.sites_suggest",
                    optionValue: "_id",
                    optionLabel: "name",
                    placeholder: "Выберите сайт",
                    showSelectAll: true,
                    refetchOnMountData: true,
                },
            },
        },
    ];

    return (
        <DefaultDetail
            apiUrl={secondParam === "add" ? "/abtest/absites" : `/abtest/absites/${secondParam}`}
            dataKey={secondParam}
            inputs={inputs}
            titleList={"title"}
            logging={true}
            title={"A/B тест для сайта"}
            titleRight={"тест"}
            scopes={false}
            page={"absites"}
            abTest={true}
        />
    );
};

export default TestSiteDetail;
